class SubscribeBanner extends HTMLElement {
  constructor() {
    super();

    this.close = this.querySelector(".js-subscribe-close");
    this.cookieName = "subscribeBannerHidden";  // Cookie name
    this.cookieValue = "true";  // Cookie value
    this.daysToExpire = this.close.dataset.expiry;  // Number of days to keep the cookie

    this.close.addEventListener("click", () => {
      this.setCookie(this.cookieName, this.cookieValue, this.daysToExpire);
      this.checkCookieAndHideElement(this.cookieName, this);
    });

    this.checkCookieAndHideElement(this.cookieName, this);
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Convert days to milliseconds
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }

  checkCookieAndHideElement(cookieName, element) {
    if (this.getCookie(cookieName)) {
      element.classList.add("hidden");
    } else {
      element.classList.remove("hidden");
    }
  }
}

customElements.define("subscribe-banner", SubscribeBanner);